import React, { Component } from 'react';
import {
  Snackbar,
  LinearProgress,
  FontIcon,
} from 'react-md';

class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      showPassword: false,
      toasts: [],
      autohide: true,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addToast = this.addToast.bind(this);
    this.dismissToast = this.dismissToast.bind(this);
    this.toggleShowPassword = this.toggleShowPassword.bind(this);
  }

  toggleShowPassword() {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.action({
      username: this.state.username,
      password: this.state.password,
    }).then((response) => {
      if (!response) {
        this.addToast('Usuario o contraseña incorrecto');
      }
    });
  }

  addToast(text, action, autohide = true) {
    this.setState((state) => {
      const toasts = state.toasts.slice();
      toasts.push({ text, action });
      return { toasts, autohide };
    });
  }

  dismissToast = () => {
    const [, ...toasts] = this.state.toasts;
    this.setState({ toasts });
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        {this.props.loading && (
          <div style={{ marginBottom: 16 }}>
            <LinearProgress id="login-progress" />
          </div>
        )}
        <div style={styles.fieldGroup}>
          <label style={styles.label} htmlFor="loginUsername">Nombre de usuario</label>
          <input
            id="loginUsername"
            style={styles.input}
            type="text"
            name="username"
            value={this.state.username}
            onChange={this.handleChange}
            disabled={this.props.disabled}
            placeholder="Ingresa tu usuario"
            required
          />
        </div>
        <div style={styles.fieldGroup}>
          <label style={styles.label} htmlFor="loginPassword">Contraseña</label>
          <div style={styles.passwordWrapper}>
            <input
              id="loginPassword"
              style={{ ...styles.input, paddingRight: 42 }}
              type={this.state.showPassword ? 'text' : 'password'}
              name="password"
              value={this.state.password}
              onChange={this.handleChange}
              disabled={this.props.disabled}
              placeholder="Ingresa tu contraseña"
              required
            />
            <button
              type="button"
              onClick={this.toggleShowPassword}
              style={styles.eyeButton}
              aria-label={this.state.showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              tabIndex={-1}
            >
              <FontIcon style={styles.eyeIcon}>
                {this.state.showPassword ? 'visibility_off' : 'visibility'}
              </FontIcon>
            </button>
          </div>
        </div>
        <button
          type="submit"
          disabled={this.props.disabled}
          style={{
            ...styles.button,
            ...(this.props.disabled ? styles.buttonDisabled : {}),
          }}
        >
          Iniciar Sesión
        </button>
        <Snackbar
          id="loginForm-snackbar"
          toasts={this.state.toasts}
          autohide={this.state.autohide}
          onDismiss={this.dismissToast}
        />
      </form>
    );
  }
}

const styles = {
  fieldGroup: {
    marginBottom: 20,
  },
  label: {
    display: 'block',
    fontSize: 13,
    fontWeight: 500,
    color: '#555',
    marginBottom: 6,
  },
  input: {
    width: '100%',
    padding: '12px 14px',
    fontSize: 14,
    border: '1px solid #ddd',
    borderRadius: 10,
    outline: 'none',
    transition: 'border-color 0.2s ease',
    backgroundColor: '#fafafa',
    color: '#333',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '13px 0',
    fontSize: 15,
    fontWeight: 600,
    color: '#fff',
    backgroundColor: '#F5A623',
    border: 'none',
    borderRadius: 10,
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    marginTop: 8,
  },
  buttonDisabled: {
    backgroundColor: '#ccc',
    cursor: 'not-allowed',
  },
  passwordWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  eyeButton: {
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  eyeIcon: {
    fontSize: 20,
    color: '#888',
  },
};

export default LoginForm;
